/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const contactDeleteBodyExpectedVersionExclusiveMin = 0;
export const contactDeleteBodyExpectedVersionMax = 9007199254740991;

export const ContactDeleteBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(contactDeleteBodyExpectedVersionExclusiveMin)
    .max(contactDeleteBodyExpectedVersionMax),
});

export type ContactDeleteBody = zod.input<typeof ContactDeleteBody>;
export type ContactDeleteBodyOutput = zod.output<typeof ContactDeleteBody>;
